import { render, staticRenderFns } from "./AdminFormulasNewScreen.vue?vue&type=template&id=0dc3ea4d&scoped=true&"
import script from "./AdminFormulasNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminFormulasNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3ea4d",
  null
  
)

export default component.exports